<template>
  <div class="step-outer-box">
    <ChapterFilter v-if="chapterDetail" :theme="chapterDetail.theme"></ChapterFilter>

    <div class="bottom-all-box" v-if="chapterDetail">
      <div class="intro-line" v-if="chapterDetail.knowledge">
        <div class="intro-line-left">实践教学大纲</div>
        <div v-if="chapterDetail" class="intro-line-right" v-html="chapterDetail.knowledge"></div>
      </div>
      <div class="intro-line" v-if="chapterDetail.target">
        <div class="intro-line-left">实践目标</div>
        <div v-if="chapterDetail" class="intro-line-right" v-html="chapterDetail.target">

        </div>
      </div>
      <div class="intro-line" v-if="chapterDetail.task_description">
        <div class="intro-line-left">线上学习</div>
        <div v-if="chapterDetail" class="intro-line-right last-line" v-html="chapterDetail.task_description"></div>
      </div>

      <div class="resource-menu">
        <div :class="['resource-menu-item', menuType == 1 ?'active':'']" @click="menuType = 1">视频资源</div>
        <div :class="['resource-menu-item', menuType == 2 ?'active':'']" @click="menuType = 2">拓展资源</div>
      </div>

      <div v-show="menuType == 1" class="resource-lists">
        <template v-if="resourceVideos&&resourceVideos.length>0">
          <div v-for="item,index in resourceVideos" :key="index" @click="previewRes(item, 3)" class="resource-box">
            <div v-if="item.is_finish == 1" class="speed-icon">{{item.learn_rate}}%</div>
            <div v-else class="finish-icon"></div>
            <div class="resource-img">
              <div class="inner_name">{{item.filename}}</div>
              <div class="inner_img" :style="`background-image: url(${item.imgurl});background-size: 100% 100%;`"></div>
            </div>
            <div class="resource-txt">
              <div class="title">{{item.filename}}</div>
            </div>
          </div>
          <div class="sub-visibility" v-for="i in 7" :key="i+'v1'"></div>
        </template>
        <a-empty v-else></a-empty>
      </div>

      <div v-show="menuType == 2" class="resource-lists">
        <template v-if="resourceReads&&resourceReads.length>0">
          <div v-for="item,index in resourceReads" :key="index" @click="previewRes(item, 4)" class="resource-box">
            <div class="word-icon">文档</div>
            <div class="resource-img">
              <div class="inner_name">{{item.filename}}</div>
              <div class="inner_img" :style="`background-image: url(${item.imgurl});background-size: 100% 100%;`"></div>
            </div>
            <div class="resource-txt">
              <div class="title">{{item.filename}}</div>
            </div>
          </div>
          <div class="sub-visibility" v-for="i in 7" :key="i+'v2'"></div>
        </template>
        <a-empty v-else></a-empty>
      </div>
    </div>

    <component ref="playerRef" :is="dialogConfig.name" :addPlayLogMethod="playLog" @closeBox="closePlayBox" :dialogConfig="dialogConfig"></component>
  </div>
</template>

<script>
import ChapterFilter from "../../../components/student/ChapterFilter";
import services from '../../../assets/js/services'
import { mapState } from "vuex";
export default {
  name: "stepOne",
  components: {
    ChapterFilter,
    PreviewPdf: () => import('../../../components/PreviewPdf'),
    PlayBox: () => import('../../../components/PlayBox'),
  },
  data () {
    return {
      dialogConfig: {
        type: "",
        name: "",
        fileId: "",
        path: "",
        title: "",
        isLevelLog: false,
        position: '',
      },
      services,
      menuType: 1,
      chapterDetail: null,
      resourceVideos: null, // 视频资源
      resourceReads: null,  // 拓展阅读
      activity_id: '',
      course_id: '',
      chapter_id: '',
      currentTime: '', // 当前视频播放的时间
      course_resource_id: '',  // 课程资源ID
    };
  },
  computed: {
    ...mapState({
      appsUserInfo: state => state.appsLogin.appsUserInfo,
    }),
  },
  mounted () {

    this.$watch('$route', this.getTaskData, { immediate: true });
  },
  methods: {
    async getTaskData () {
      let query = this.$route.query
      let params = {
        activity_id: query.activity_id,
        course_id: query.course_id,
        chapter_id: query.chapter_id,
      }
      this.activity_id = query.activity_id
      this.course_id = query.course_id
      this.chapter_id = query.chapter_id
      let result = await services.getCenterTaskData({ code: "t001", ...params })
      if (result.code == "0000") {
        this.chapterDetail = result.data.chapter
        this.resourceVideos = result.data.course_resource_videos.map((item, index) => {
          let ind = (index % 16) + 1;
          item.imgurl = require(`../../../assets/image/student/default/video/${ind}.jpg`);
          return item;
        });
        this.resourceReads = result.data.course_resource_reads.map((item, index) => {
          let ind = (index % 16) + 1;
          item.imgurl = require(`../../../assets/image/student/default/word/${ind}.jpg`)
          return item
        })
      }
    },
    // 文件预览
    previewRes (item, type) {
      let that = this
      // if (item.covert_status == "2") return this.$message.info("请等待转码完成后预览")
      this.course_resource_id = item.id
      this.dialogConfig.title = item.filename
      this.dialogConfig.type = type
      if (type == 1 || type == 4) {
        // 文档
        this.dialogConfig.path = item.view_url || item.url;
        this.dialogConfig.name = 'PreviewPdf';
      } else if (type == 3) {
        // 视频
        services.getSteponeVideo({
          id: item.id,
          activity_id: that.activity_id,
          course_id: that.course_id,
          chapter_id: that.chapter_id,
        }).then(res => {
          if (res.code == '0000') {
            that.dialogConfig.fileId = res.data.file_id
            that.dialogConfig.name = 'PlayBox';
            that.dialogConfig.isLevelLog = true
            that.dialogConfig.position = res.data.position ? res.data.position : 0
          }
        })
      }
    },
    // 关闭播放器弹窗 添加视频学习记录
    closePlayBox () {
      this.getTaskData()
    },
    playLog () {
      // 清除之前的定时器
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }

      // 设置新的定时器
      this.timeoutId = setTimeout(() => {
        // 获取当前播放时间
        if (this.$refs.playerRef && this.$refs.playerRef.player) {
          this.currentTime = this.$refs.playerRef.player.currentTime();
        }

        // 发送请求
        services.getSteponeVideoLearn({
          school_id: this.appsUserInfo.school_id,
          activity_id: this.activity_id,
          course_id: this.course_id,
          chapter_id: this.chapter_id,
          course_resource_id: this.course_resource_id,
          position: this.currentTime,
          user_id: this.appsUserInfo.id,
        });
      }, 300); // 300ms 内只执行最后一次调用
    },

  },
  beforeDestroy () {
    clearInterval(this.timer);
  }
};
</script>

<style lang="less" scoped>
.step-outer-box {
    width: 100%;
    background: #ffffff;
    .bottom-all-box {
        border: 1px solid #e7eaec;
        padding: 18px 25px;
    }
    .intro-line {
        display: flex;
        margin-bottom: 16px;
        .intro-line-left {
            width: 114px;
            text-align: center;
            padding: 0 15px;
            height: 28px;
            background: #bc7a6e;
            font-size: 14px;
            color: #ffffff;
            line-height: 28px;
            border-radius: 14px 0px 0px 14px;
        }
        .intro-line-right {
            flex: 1;
            max-height: 120px;
            overflow-y: auto;
            background: #f8f8f8;
            line-height: 20px;
            border-radius: 4px;
            font-size: 14px;
            color: #7e8287;
            min-height: 28px;
            padding: 4px 15px;
            &.last-line {
                background: #fff3f2;
                font-size: 14px;
                color: #2f2626;
            }
        }
    }
    .resource-menu {
        width: 100%;
        border-bottom: 1px solid #ebeef1;
        padding: 12px 0 0 15px;
        background: #fff url('../../../assets/image/student/stepOne/bian.png')
            no-repeat;
        background-position: bottom right;
        background-size: 304px auto;
        margin-bottom: 20px;
        .resource-menu-item {
            display: inline-block;
            font-weight: bold;
            font-size: 14px;
            color: #3c3c3e;
            padding-bottom: 20px;
            position: relative;
            margin-right: 30px;
            cursor: pointer;
            &.active::after {
                content: '';
                display: block;
                width: 26px;
                height: 3px;
                background: #b84b3c;
                position: absolute;
                left: 50%;
                bottom: -1px;
                transform: translateX(-50%);
            }
            &.active {
                color: #a82822;
            }
        }
    }
    .resource-lists {
        width: 100%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding-bottom: 15px;
        .resource-box {
            flex: 0 0 220px;
            float: left;
            background: #fff;
            cursor: pointer;
            margin-bottom: 20px;
            position: relative;
            .speed-icon {
                position: absolute;
                right: 0;
                top: 0;
                z-index: 10;
                display: block;
                width: 46px;
                height: 24px;
                line-height: 24px;
                background: linear-gradient(90deg, #f78d5a 0%, #e86d37 100%);
                border-radius: 0px 0px 0px 4px;
                border: 1px solid #ffffff;
                text-align: center;
                font-weight: bold;
                font-size: 12px;
                color: #ffffff;
            }
            .finish-icon {
                width: 24px;
                height: 24px;
                background: url('../../../assets/image/student/stepOne/wancheng.png')
                    no-repeat center/cover;
                position: absolute;
                right: 3px;
                top: 3px;
                z-index: 10;
            }
            .word-icon {
                position: absolute;
                right: 0;
                top: 0;
                z-index: 10;
                display: block;
                width: 46px;
                height: 24px;
                line-height: 24px;
                background: linear-gradient(90deg, #cfa47f 0%, #ac6b46 100%);
                border-radius: 0px 0px 0px 4px;
                border: 1px solid #ffffff;
                text-align: center;
                font-weight: bold;
                font-size: 12px;
                color: #ffffff;
            }
            &:hover .resource-txt {
                background: #fff3f2;
                border: 1px solid #e7eaec;
                .title {
                    color: #a82822;
                }
            }
            &:hover .resource-img .inner_img {
                transform: scale(1.1);
            }

            .resource-img {
                height: 122px;
                width: 100%;
                overflow: hidden;
                .inner_img {
                    width: 100%;
                    height: 100%;
                    background-size: cover !important;
                    background-repeat: no-repeat;
                    background-position: 50%;
                    transition: all 0.8s;
                }
                .inner_name {
                    color: #ca0808;
                    font-size: 15px;
                    font-weight: bold;
                    width: 80%;
                    text-shadow: rgba(255, 255, 255, 0.6) 1px 1px 2px;
                    text-align: center;
                    position: absolute;
                    z-index: 9;
                    left: 50%;
                    top: 32%;
                    transform: translate(-50%, -50%);
                }
            }
            .resource-txt {
                padding: 15px;
                width: 220px;
                box-sizing: border-box;
                border: 1px solid #e7eaec;
                .title {
                    font-family: Microsoft YaHei;
                    color: #3c3c3e;
                    font-size: 13px;
                    line-height: 20px;
                    height: 40px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
            }
        }
        .sub-visibility {
            flex: 0 0 220px;
            display: inline-block;
            overflow: visible;
        }
    }
}
</style>
